import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { blueprintsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

export const autoMatchBlueprint = async (
  source_id: string,
  namespace: string,
) => {
  try {
    const url = blueprintsUrlEnvVar();
    const response = await axios.get(
      `${url}/api/v3/ns/${namespace}/blueprints/auto-match-blueprint/${source_id}`,
      {
        headers: buildAxiosAuthenticationHeaders(),
        // Keep non-2xx responses in normal flow so callers can branch on status/body.
        validateStatus: () => true,
      },
    );

    return {
      status: response.status,
      body: response.data,
    };
  } catch (err) {
    navigateTo(Route.SERVER_ERROR);
    return {
      status: 500,
      body: {
        message: "An unexpected error occurred.",
      },
    };
  }
};
